/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export const options = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#fff",
      borderColor: "#e5e7eb",
      borderWidth: 1,
      titleColor: "#000",
      bodyColor: "#000",
      padding: 10,
      callbacks: {
        label: function (context) {
          return `${context.label}: ${context.raw} m³/s`;
        },
      },
    },
    datalabels: {
      anchor: "end",
      align: "right",
      formatter: (value) => `${value} m³/s`,
      color: "#000",
      font: {
        size: 12,
        weight: "bold",
        family: "'Segoe UI', sans-serif",
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#4B5563",
        font: {
          size: 12,
        },
      },
      grid: {
        drawOnChartArea: false,
      },
    },
    y: {
      ticks: {
        color: "#4B5563",
        font: {
          size: 13,
          weight: "bold",
        },
      },
      grid: {
        color: "#E5E7EB",
      },
    },
  },
};

const labels = [
  "Buxoro",
  "Qoraqalpog‘iston",
  "Qashqadaryo",
  "Xorazm",
  "Surxondaryo",
  "Navoiy",
];

const BarChart5 = ({ arr }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Suv oqimi",
        data: arr,
        backgroundColor: arr.map(() => "#4F46E5"),
        borderRadius: 6,
        barThickness: 20,
      },
    ],
  };

  return (
    <div
      style={{
        height: "280px",
        width: "100%",
        maxWidth: "800px",
      }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default BarChart5;
